 var swiper = new Swiper(".featured_reviews_slider", {
      centeredSlides: false,	
      loop: true,
      slidesPerView: 2.5,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
     breakpointsInverse: true,
     breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 1,
      spaceBetween: 40,
    }
  }
});

const optionsSliderv2 = {
    centeredSlides: false,	
    slidesPerView: 1.4,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween : 10,
        pagination: {
          el: ".swiper-pagination",
        },
        slideToClickedSlide: true,
    allowTouchMove: true,
      },
      992: {
        slidesPerView: 1.2,
        spaceBetween: 0,
         slideToClickedSlide: false,
    allowTouchMove: false,
      }
    },
  on: {
        init: function () {
            updateNavButtons(this); 
        },
        slideChange: function () {
            updateNavButtons(this);
        }
    }
};

function updateNavButtons(swiper) {
    let nextButton = document.querySelector('.swiper-button-next');
    let prevButton = document.querySelector('.swiper-button-prev');
    let totalSlides = swiper.slides.length;
    let slidesPerView = swiper.params.slidesPerView;
    
    let isEnd = swiper.isEnd;
    if (isEnd) {
        nextButton.classList.add("blurred");
    } else {
        nextButton.classList.remove("blurred");
    }
}

var productGalleryV2 = new Swiper(".product-slider-v2", optionsSliderv2);
setTimeout(function(){
  activateSlider();
},100);

function activateSlider(){
  var sliders = document.getElementsByClassName("product-area__media");
  Array.from(sliders).forEach(slider => {
    slider.style.visibility = 'visible';
  })
}

/** Quick View Product Slider **/
let modalOpenHandled = false;

const observer = new MutationObserver((mutations) => {
  if (!modalOpenHandled && document.body.classList.contains('modal-active')) {
    setTimeout(function(){
      new Swiper(".product-slider-v2", optionsSliderv2);
      activateSlider()
    },100)
  }
});

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ['class']
});


const observer2 = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if nodes were removed
    if (mutation.removedNodes.length) {
      // Look for the quantity input
      const quantityWrapper = document.querySelector('.quantity-wrapper');
      if (!quantityWrapper) {
        // If quantity wrapper is gone, find and hide the label
        const quantityLabel = document.querySelector('.quantity-selector');
        if (quantityLabel) {
          quantityLabel.style.display = 'none';
        }
        
        // Also hide the entire wrapper if it exists
        const wrapperDiv = document.querySelector('.quantity-selector-wrapper');
        if (wrapperDiv) {
          wrapperDiv.style.display = 'none';
        }
      }
    }
  });
});

// Start observing the document with the configured parameters
observer2.observe(document.body, {
  childList: true,
  subtree: true
});
  
(function () {
  $(document).on("shopify:section:load", function (event) {

  });
})();
